import { Dialog } from '@mui/material';
import { Wallet } from '../../../../api';
import { Button } from '../../../../components';
import { PaymentCard } from './PaymentCard';

type MarkDeleteConfirmationModalProps = {
    open: boolean;
    wallet: Wallet;
    type: 'delete' | 'preferred';
    isUpdating?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

export const MarkDeleteConfirmationModal: React.FC<
    MarkDeleteConfirmationModalProps
> = ({ open, wallet, type, isUpdating, onConfirm, onCancel }) => {
    return (
        <Dialog
            open={open}
            onClose={() => { if (!isUpdating) onCancel(); }}
            container={document.getElementById('root')}
            sx={{
                '& .MuiBackdrop-root': { backgroundColor: '#f1f0f7cc' },
                '& .MuiDialog-paper': {
                    borderRadius: '24px',
                    padding: '40px 24px',
                    backgroundColor: '#ffffff',
                    boxShadow:
                        '0 1px 6px 0 rgba(10, 0, 77, 0.04), 0 5.5px 30px 0 rgba(10, 0, 77, 0.05)',
                    minWidth: 320,
                    maxWidth: 400,
                    mx: { xs: 2, sm: 'auto' },
                },
            }}
        >
            <div data-testid="confirm-modal-content" className="flex flex-col">
                <div data-testid="confirm-modal-body" className="flex flex-col gap-4 mb-6">
                    <div data-testid="confirm-question" className="text-heading-small text-primary">
                        {type === 'preferred'
                            ? 'Are you sure you want to make this card your preferred payment method?'
                            : 'Are you sure you want to remove this payment method from your wallet?'}
                    </div>
                    {type === 'delete' && (
                        <div data-testid="recurring-warning" className="text-body-medium text-primary">
                            Any recurring gifts associated with this card will
                            be cancelled.
                        </div>
                    )}
                </div>
                <PaymentCard
                    accountType={wallet.type}
                    accountNumber={wallet.number}
                    isPreferred={wallet.isPreferred}
                />
                <div data-testid="confirm-modal-actions" className="flex flex-col items-center gap-4 mt-6">
                    <Button
                        data-testid="confirm-yes-button"
                        className="w-full"
                        loading={isUpdating}
                        onClick={onConfirm}
                    >
                        Yes
                    </Button>
                    <Button
                        data-testid="confirm-cancel-button"
                        variant="link"
                        disabled={isUpdating}
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
